import { CustomTabPanel } from '@/erp/sale';
import { a11yProps, sizeTab, useTabsFormOnly } from '@/shared';
import { SingleTableBoxScene } from '@/shared/components/ui';
import { Box, Tab, Tabs } from '@mui/material';
import React from 'react'
import TableGestionOportunidadComercialFilterPlan from '../../shared/table_oportunidad_comercial_filter_plan/TableGestionOportunidadComercialFilterPlan';
import { TipoPlanCorporativo } from '@/shared/interfaces';

type Props = {}

const OportunidadComercialTipoPlan = ({
    
}: Props) => {

    const {
        setValueTab,
        valueTab,
    } = useTabsFormOnly({initialTabValue: 0})

    return (
    <SingleTableBoxScene
    title={"Oportunidad Comercial Por Subtipo de Contrato"}
    visibleReport={true}
    >
    <Box
        sx={{
        bgcolor: "background.paper",
        maxWidth: sizeTab,
        paddingBottom: 2,
        }}
    >
        <Tabs
        value={valueTab}
        onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
        }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="scrollable force tabs preventa"
        >
            <Tab label={"DEMO"} {...a11yProps(0)} />
        </Tabs>
    </Box>
    <CustomTabPanel value={valueTab} index={0}>
        <TableGestionOportunidadComercialFilterPlan
        enableEditing={true}
        showCustomActionBtnSpace={true}
        tipo_plan={`${TipoPlanCorporativo.DEMO_CORPORATIVO},${TipoPlanCorporativo.DEMO},${TipoPlanCorporativo.DEMO_ISP},${TipoPlanCorporativo.DEMO_INSTITUCIONALES},${TipoPlanCorporativo.DEMO_XPON}`}
        />
    </CustomTabPanel>
    </SingleTableBoxScene>
  )
}

export default OportunidadComercialTipoPlan